export const buildUserFromLoginData = (data) => ({
  id: data.id,
  username: data.username,
  email: data.email,
  profileImage: data.profileImage,
  name: data.name,
  reviewsCount: data.reviewsCount,
  reviewsAverage: data.reviewsAverage,
  isLoggedIn: data.isLoggedIn,
  locations: data.locations,
  verificationStatus: data.verificationStatus,
});
